import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { toast } from "react-toastify";
import { Box, Button, AppBar, IconButton, Drawer, Toolbar, Tooltip, Grid, } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import MenuIcon from '@mui/icons-material/Menu';
import SyncIcon from '@mui/icons-material/Sync';
import { useNavigate } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useDispatch, useSelector } from "react-redux";
import View194N from './view194N'
import ViewNetwork from './viewNetworkCertificate'
import Footer from "../Footer";
import IconTextField from "../TextField";
import action from '../../redux/action';
import { _IMAPI } from "../../assets/js/imapi";
import DashboardIcon from "../../assets/images/dashboard.png";
import { getToastOptions } from '../../utils/backdrop';
import useGetBalance from "../../Hooks/useFetchBalance"
import { CONFIG } from "../../Config"
import Loader from '../Loader';
import AnchorMenu from '../AnchorMenu';
import SidebarMenus from "../Drawer";
import ElectionLetter from './ElectionLetter';
import dayjs from 'dayjs';
import { authLogout } from '../../services/auth';


function RDrawer(props) {
    const { window1, prodGrouID } = props;

    let navigate = useNavigate();
    const dispatch = useDispatch();

    const { fetchBalance } = useGetBalance()

    const profileData = useSelector(state => state.profileData);
    const balance = useSelector(state => state.accountBalance);
    const storeMenuItems = useSelector(state => state.menuItems);
    const dynamicMenus = useSelector(state => state.dynamicMenus);

    const [loaderState, setLoaderState] = useState({ loading: false, msg: "" });
    const [isGettingBalance, setIsGettingBalance] = useState({ loading: false, msg: "" });
    const [alertMsg, setAlertMsg] = useState('');
    const [openDrawer, setOpenDrawer] = useState(false);

    const [show194n, setShow194N] = useState(false);
    const [viewNetwork, setViewNetwork] = useState(false);
    const [viewElectionLetter, setViewElectionLetter] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuItems, setMenuItems] = useState([]);
    const [query, setQuery] = useState('');
    const [printElection, setPrintElection] = useState(false);
    const open = Boolean(anchorEl);
    const toastOptions = getToastOptions(dispatch, action);

    window.onafterprint = (event) => {
     
        setPrintElection(false)
    };


    const dashboardMenu = [{
        id: 111,
        title: "DASHBOARD",
        path: '/dashboard',
        prod_code: "NA",
        image_src: DashboardIcon,
        selected: false,
        user_role: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"]
    }]


    useEffect(() => {

        let interval = setInterval(() => {

            _IMAPI.fetchGeoLocation().then((location) => {

                _IMAPI.geoLocation = location;

            }).catch((error) => {
                _IMAPI.geoLocation = null
                alert(error.message);

            })

        }, 1000 * 60 * 5);

        if (CONFIG.SHOW_ALERT) {
            getNotification();
        }

        return () => {

            clearInterval(interval);
        };

    }, []);



    useEffect(() => {

        let selectedItem = storeMenuItems.filter((item) => { return item.selected });


        let filteredStaticMenus = profileData.guid === "global" ? CONFIG.SIDEBAR_MENUS.filter((menu) => menu.title !== "ADMIN") : CONFIG.SIDEBAR_MENUS;


        if (Number(prodGrouID) === 12) {
            filteredStaticMenus = filteredStaticMenus.filter((eachMenu) => eachMenu.title !== "FUNDING")
        }

        let menus = dashboardMenu.concat(dynamicMenus, filteredStaticMenus);


        let result = menus.map((eachMenu) => {

            if ((eachMenu.id === selectedItem[0]?.id) && selectedItem[0]?.selected) {
                return { ...eachMenu, selected: true }
            }

            return { ...eachMenu, selected: false }

        });

        setMenuItems(result);

    }, [dynamicMenus, prodGrouID]);

    useEffect(() => {

        if (printElection) {

            window.print();

        }

    }, [printElection]);


    const handleDrawerToggle = () => {
        setOpenDrawer((pre) => !pre)


    }

    const checkProduct = (product, callback) => {

        setLoaderState(pre => ({ ...pre, loading: true }));

        let prod_code = product === "PG_WALLET" ? "PG" : product;

        _IMAPI._POST(_IMAPI.getService("check-products1"), {}, { product_code: prod_code }, (res) => {

            setLoaderState(pre => ({ ...pre, loading: false }));
            if (res.data.status === "error") {
                callback({ hasScheme: false, hasVendor: false, msg: res.data.msg });
                return;
            }

            const hasScheme = res.data.scheme[0] && res.data.scheme[0].length > 0 ? true : false;
            const hasVendor = res.data.vendors && res.data.vendors.length > 0 ? true : false;
            let msg = ""

            if (!hasScheme && !hasVendor) {
                msg = "No Scheme and Vendor found for you on this Product"
            } else if (!hasScheme) {
                msg = "No Scheme found for you on this Product"
            } else if (!hasVendor) {
                msg = "No Vendor found for you on this Product"
            } else {

            }
            callback({ hasScheme, hasVendor, msg })

        }, (err) => {
            setLoaderState(pre => ({ ...pre, loading: false }))

            let data = err.response ? err.response.data : err;
            toast.error(data.message)

        });
    }



    const onClickProduct = (item) => {
        const result = menuItems.map((obj) => {
            if (item.path) {
                if (item.id === obj.id) {
                    obj.selected = true
                } else {
                    obj.selected = false;

                }

            } else {
                if (item.id === obj.id) {
                    obj.selected = !obj.selected;
                } else {
                    obj.selected = false
                }
            }
            return obj;
        });

        if (item.prod_code) {
            if (item.prod_code === "BILLPAY_BB" || item.prod_code === "NA") {
                navigate(item.path)

            } else {
                checkProduct(item.prod_code, (res) => {

                    let { hasScheme, hasVendor, msg } = res;
                    if (hasScheme && hasVendor) {
                        navigate(item.path)
                    } else {
                        toast.error(msg, toastOptions)
                    }

                });
            }

        }

        setMenuItems(result);
        dispatch(action.storeSideBarMenuItem(result))

    };


    const innerMenuItem = (item) => {
       
        if (item.prod_code) {

            checkProduct(item.prod_code, (res) => {

                let { hasScheme, hasVendor, msg } = res;
                if (hasScheme && hasVendor) {
                    navigate(item.path)
                } else {
                    toast.error(msg, toastOptions)
                }

            });

        } else {
            navigate(item.path);
        }
    }


    const logOut = async () => {
        try {
            setLoaderState(pre => ({ ...pre, loading: true }));
            await authLogout();
            setLoaderState(pre => ({ ...pre, loading: false }));
            localStorage.clear();
            dispatch(action.logout());
            _IMAPI.geoLocation = null;
            navigate("/login")

        } catch (error) {
            setLoaderState(pre => ({ ...pre, loading: false }));
        }
    }

    const getNotification = () => {
        setLoaderState(pre => ({ ...pre, loading: true }))
        _IMAPI._GET(_IMAPI.getService("bank-alert"), {}, {}, (res) => {
            setLoaderState(pre => ({ ...pre, loading: false }));
            if (res.data.status === "error") {

                return;
            }
            let alert = res.data.data?.alert_msg
            setAlertMsg(alert)
        }, (err) => {
            setLoaderState(pre => ({ ...pre, loading: false }));
            let data = err.response ? err.response.data : err;
            toast.error(data.message)

        })
    }

    const handleCloseShow194N = () => {
        setShow194N(false);
    }

    const handleCloseViewNetwork = () => {
        setViewNetwork(false)
    }

    const handleCloseElectionLetter = () => {
        setViewElectionLetter(false)
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);

    }
    const handleClose = () => {
        setAnchorEl(null);
    }

    let date = dayjs("2022/05/18").format("DD/MM/YYYY");

    const printElectionLetter = useCallback(() => {

        setPrintElection(true);

    }, [])

    const print = useCallback(() => {
        window.print();
    }, [])


    const container = window1 !== undefined ? () => window().document.body : undefined;


    return (
        <>
            {

                <Box className="flex">
                    <CssBaseline />
                    <AppBar position="fixed">
                        <Grid container className="alignI-center" sx={{ display: { xs: 'none', lg: 'flex' } }}>

                            <Grid item xs={1}  >

                                {CONFIG.SHOW_SIDEBAR ?
                                    <IconButton onClick={() => navigate('/products')} size="small" aria-haspopup="true">
                                        <HomeIcon className="homeIcon" />
                                    </IconButton> :
                                    <img
                                        src={CONFIG.APPBARLOGO}
                                        height="45px"
                                        alt="logo"
                                        className="pointer"
                                        onClick={() => navigate('/products')}
                                    />
                                }
                            </Grid>



                            <Grid item xs={11} container className="lg_searchContainer" >

                                {CONFIG.SHOW_SEARCHBAR && <Grid item lg={3}>
                                    <IconTextField
                                        value={query}
                                        onKeyPress={(e) => {

                                            if (e.key === "Enter") {

                                                navigate({ pathname: '/search', search: `?q=${e.target.value}` });
                                                setQuery('')
                                            }
                                        }}
                                        onChange={(e) => setQuery(e.target.value)}

                                        placeholder='Search Transaction...'


                                    />
                                </Grid>}

                                <Grid item lg="auto" className="flex col-gap-10"  >

                                    {CONFIG.SHOW_WALLET_BALANCE && <div className="flex">
                                        <Button variant="prepaidBtn" >
                                            <span > Prepaid {balance.prepaid ? balance.prepaid : "0"}</span>
                                        </Button>
                                        <Button variant="postpaidBtn">
                                            <span> Postpaid {balance.postpaid ? balance.postpaid : "0"}</span>
                                        </Button>
                                        {/* <Button variant="postpaidBtn">
                                            <span> Gullak {balance.wallet3 || "0"}</span>
                                        </Button> */}
                                        <Button variant="refetchBalance"
                                            onClick={() => fetchBalance(setIsGettingBalance)} >
                                            <SyncIcon className={isGettingBalance.loading ? "refresh" : "idle"} />
                                        </Button>
                                    </div>}



                                    {CONFIG.SHOW_GUID && <Button variant="outlined" >
                                        <span >{profileData.guid}</span>
                                    </Button>}

                                </Grid>

                                <Grid item lg="auto" >

                                    <Tooltip title={profileData.account_name}>
                                        <IconButton
                                            onClick={handleClick}
                                            size="small"
                                            aria-controls={open ? 'account-menu' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                        >
                                            <AccountCircleIcon variant="btnIcon" className="profileIcon" />
                                        </IconButton>
                                    </Tooltip>
                                </Grid>

                            </Grid>

                        </Grid>

                        <Grid container className="jsutifyC-center" sx={{ display: { xs: 'flex', lg: 'none' }, rowGap: "5px"}}>

                            <Grid item xs={CONFIG.SHOW_SEARCHBAR ? 3 : 8}>
                                {CONFIG.SHOW_SIDEBAR &&
                                    <IconButton size="small" aria-haspopup="true" onClick={handleDrawerToggle} sx={{ display: { md: 'none' } }}>
                                        <MenuIcon />
                                    </IconButton>
                                }
                                {CONFIG.SHOW_SIDEBAR ?
                                    <IconButton onClick={() => navigate('/products')} size="small" aria-haspopup="true">
                                        <HomeIcon />
                                    </IconButton> :
                                    <img src={CONFIG.APPBARLOGO} height="45px" alt="logo" className="pointer" onClick={() => navigate('/products')} />
                                }
                            </Grid>

                            {CONFIG.SHOW_SEARCHBAR && <Grid item xs={5} className="alignS-center"  >
                                <IconTextField
                                    value={query}
                                    onKeyPress={(e) => {

                                        if (e.key === "Enter") {

                                            navigate({ pathname: '/search', search: `?q=${e.target.value}` });
                                            setQuery('')
                                        }
                                    }}
                                    onChange={(e) => setQuery(e.target.value)}
                                    placeholder='Search Transaction...'


                                />
                            </Grid>}

                            <Grid item xs={4} className="flex justifyC-end" >

                                {CONFIG.SHOW_WALLET_BALANCE && <IconButton size="small" aria-haspopup="true"
                                    onClick={() => fetchBalance(setIsGettingBalance)}>
                                    <SyncIcon className={isGettingBalance.loading ? "refresh" : "idle"} />
                                </IconButton>}

                                <Tooltip title={profileData.account_name}>
                                    <IconButton
                                        onClick={handleClick}
                                        size="small"
                                        aria-controls={open ? 'account-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={open ? 'true' : undefined}
                                    >
                                        <AccountCircleIcon variant="btnIcon" className="profileIcon" />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                            {CONFIG.SHOW_WALLET_BALANCE &&
                                <>
                                    <Grid item xs={12} sm={CONFIG.SHOW_GUID ? 3 : 6} className="flex justifyC-center"  >

                                        <Button  variant="outlined">
                                            <span > Prepaid {balance.prepaid ? balance.prepaid : "0"}</span>
                                        </Button>


                                    </Grid>
                                    <Grid item xs={12} sm={CONFIG.SHOW_GUID ? 3 : 6} className="flex justifyC-center"  >
                                        <Button  variant="outlined">
                                            <span >Postpaid {balance.postpaid ? balance.postpaid : "0"}</span>
                                        </Button>

                                    </Grid>
                                    {/* <Grid item xs={12} sm={CONFIG.SHOW_GUID ? 3 : 6} className="flex justifyC-center"  >
                                        <Button  variant="outlined">
                                            <span >Gullak {balance.wallet3 ? balance.wallet3 : "0"}</span>
                                        </Button>

                                    </Grid> */}
                                    {CONFIG.SHOW_GUID && <Grid item xs={12} sm={3} className="flex justifyC-center "  >
                                        <Button  variant="outlined">
                                            <span >{profileData.guid}</span>
                                        </Button>

                                    </Grid>}
                                </>}

                        </Grid>
                    </AppBar>


                    <Box

                        component="nav"
                        className="navContainer"
                        aria-label="mailbox folders"
                    >
                        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                        <Drawer
                            container={container}
                            variant="temporary"
                            open={openDrawer}
                            onClose={handleDrawerToggle}
                            ModalProps={{
                                keepMounted: true, // Better open performance on mobile.
                            }}

                        >
                            <SidebarMenus

                                menuItems={menuItems}
                                onClickProduct={onClickProduct}
                                profileData={profileData}
                                innerMenuItem={innerMenuItem}
                            />

                        </Drawer>
                        <Drawer
                            variant="permanent"

                        >
                            <SidebarMenus

                                menuItems={menuItems}
                                onClickProduct={onClickProduct}
                                profileData={profileData}
                                innerMenuItem={innerMenuItem}

                            />

                        </Drawer>
                    </Box>
                    <Box
                        component="main"
                        className="mainContainer"

                    >
                        <Toolbar />
                        {alertMsg &&
                            <marquee direction="left" className="movingTextStyle">
                                {alertMsg}
                            </marquee>}

                        <Box sx={{ position: 'relative', zIndex: 1 }}>
                            <Loader open={loaderState.loading} message={loaderState.msg} />
                            {props.children}

                        </Box>

                        <Footer />
                    </Box>
                </Box>

            }

            <AnchorMenu
                anchorEl={anchorEl}
                open={open}
                handleClose={handleClose}
                setShow194N={setShow194N}
                setViewNetwork={setViewNetwork}
                setViewElectionLetter={setViewElectionLetter}
                profileData={profileData}
                logOut={logOut}
            />



            {show194n && <View194N
                open={show194n}
                profileData={profileData}
                handleClose={handleCloseShow194N}
                print={printElectionLetter}
                printElection={printElection}
                date={date}
            />}
            {viewNetwork && <ViewNetwork
                open={viewNetwork}
                profileData={profileData}
                handleClose={handleCloseViewNetwork}
                print={print}
            />}

            {viewElectionLetter && <ElectionLetter
                open={viewElectionLetter}
                profileData={profileData}
                handleClose={handleCloseElectionLetter}
                print={printElectionLetter}
                printElection={printElection}
            />}
        </ >
    );
}

RDrawer.propTypes = {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
};

export default React.memo(RDrawer);

